/**
 * SectionWrapper — applies layout_config (padding, background) and
 * responsive hide rules from responsive_config to each section.
 */

const PADDING_MAP = {
  none: '0',
  sm:   '0.75rem 1rem',
  md:   '1.5rem 1rem',
  lg:   '2.5rem 1rem',
  xl:   '4rem 1rem',
};

const BG_MAP = {
  white:    '#fff',
  surface:  '#f8fafc',
  gradient: null, // uses CSS var
  primary:  null, // uses CSS var
};

function bootstrapHideClasses(hideOn = []) {
  // Returns Bootstrap responsive display classes for hiding on given breakpoints
  const classes = [];
  if (hideOn.includes('mobile')) classes.push('d-none', 'd-md-block');
  if (hideOn.includes('tablet')) classes.push('d-none', 'd-md-none', 'd-lg-block');
  if (hideOn.includes('desktop')) classes.push('d-lg-none');
  return classes.join(' ');
}

// Section types that manage their own background, padding, and layout entirely.
const SELF_MANAGED = new Set(['hero', 'nav_menu']);

export default function SectionWrapper({ section, children, theme }) {
  const { layout_config = {}, responsive_config = {} } = section;
  const hideOn = responsive_config.hide_on || [];
  const hideClass = bootstrapHideClasses(hideOn);

  // Stable anchor so NavMenuSection scroll-spy and smooth-scroll can find this section.
  const sectionId = section.id ? String(section.id) : undefined;

  // Self-managed sections (e.g. hero, nav_menu) control their own background and padding.
  if (SELF_MANAGED.has(section.section_type)) {
    return (
      <section
        id={sectionId ? `section-${sectionId}` : undefined}
        data-section-id={sectionId}
        className={hideClass || undefined}
        style={{ width: '100%', overflow: 'hidden' }}
      >
        {children}
      </section>
    );
  }

  const padding = PADDING_MAP[layout_config.padding] || PADDING_MAP.lg;
  const bg = layout_config.background;
  let background;
  if (bg === 'gradient') {
    background = 'var(--gradient-bg)';
  } else if (bg === 'primary') {
    background = 'var(--primary-color)';
  } else if (bg === 'surface') {
    background = '#f8fafc';
  } else {
    background = '#fff';
  }
  // Per-section custom color set in TextBlock "Section Background" overrides the named bg.
  if (layout_config.customBgColor) {
    background = layout_config.customBgColor;
  }

  const maxWidth = layout_config.max_width === 'full' ? '100%'
    : layout_config.max_width === 'container' ? '1140px'
    : layout_config.max_width || '100%';

  return (
    <section
      id={sectionId ? `section-${sectionId}` : undefined}
      data-section-id={sectionId}
      className={hideClass || undefined}
      style={{ background, padding, width: '100%' }}
    >
      <div style={{ maxWidth, margin: '0 auto', width: '100%' }}>
        {children}
      </div>
    </section>
  );
}
